import {h, Fragment} from "preact"
import { useEffect, useState } from 'preact/hooks';

const MenuLink = ({ active, title, url }) => {
  return (
    <li>
      <a href={url} class={active ? "active" : ""}>
        {title}
      </a>
    </li>
  );
};

const SubMenu = ({ links = [], title, index }) => {
  const checked = links.some(({ active }) => active);
  return (
    <li class="parent-nav">
      <input id={`sb-trigger-${index}`} type="checkbox" checked={checked} />
      <label for={`sb-trigger-${index}`}>
        <h6>{title}</h6>
      </label>
      <ul class="sub-nav">
        {links.map((sublink) => (
          <MenuLink {...sublink} />
        ))}
      </ul>
    </li>
  );
};

export default () => {
  const [submenu, setSubmenu] = useState(window?.cj?.submenu);

  useEffect(() => {
    if (window?.cj?.submenu) {
      setSubmenu(window.cj.submenu);
    }
  }, []);

  if (!submenu) return null;

  const { title = "", links = [] } = submenu;

  if (!(links?.length > 0) || !title) return null;

  return (
    <ul class="sec-sidebar sidebar-nav">
      <li class="sidebar-nav--menu-title">
        <h6>{title}</h6>
      </li>
      {links.map((link, index) => {
        if (link?.links?.length > 0) {
          return <SubMenu {...link} index={index} />;
        }

        return (<MenuLink {...link} />);
      })}
    </ul>
  );
}
